type TranslationKeys = {
  // App navigation
  nav_overview: string;
  nav_orders: string;
  nav_invoices: string;
  nav_settings: string;
  loading: string;
  hide: string;

  // Dashboard
  dashboard_title: string;
  dashboard_load_error: string;
  refresh: string;
  invoices_total: string;
  draft: string;
  issued: string;
  validation_failed: string;
  orders_total: string;
  paid: string;
  open: string;
  unfulfilled: string;
  latest_invoices: string;
  no_invoices_yet: string;
  col_invoice: string;
  col_order: string;
  col_customer: string;
  col_date: string;
  col_total: string;
  col_status: string;
  col_actions: string;
  current_plan: string;
  billing_period: string;
  reset_on: string;
  document_usage: string;
  remaining_in_period: string;
  monthly_limit_reached: string;
  status_issued: string;
  status_draft: string;
  status_cancelled: string;
  manage_plan: string;
  manage_plan_tooltip: string;

  // Orders
  orders_title: string;
  orders_load_error: string;
  latest_shopify_orders: string;
  orders_loading: string;
  no_orders_found: string;
  create_invoice: string;
  create_invoice_from_order: string;
  order_id: string;
  order_id_placeholder: string;
  creating: string;
  invoice_created: string;
  invoice_already_exists: string;
  invoice_already_created: string;
  invoice_created_hint: string;
  reversed_order_hint: string;
  financial_paid: string;
  financial_pending: string;
  financial_authorized: string;
  financial_partially_paid: string;
  financial_refunded: string;
  financial_voided: string;
  entries: string;
  per_page: string;

  // Invoices
  invoices_title: string;
  invoices_load_error: string;
  monthly_limit_error: string;
  issue_error: string;
  unknown_error: string;
  download_error: string;
  search_placeholder: string;
  filter_all: string;
  no_invoices_empty: string;
  no_invoices_filter: string;
  issuing: string;
  issue: string;
  document_limit_reached: string;
  plan_limit_reached: string;
  documents_used: string;

  // Cancel / Credit note
  cancel_invoice: string;
  cancel_invoice_confirm: string;
  cancel_invoice_explanation: string;
  cancel_invoice_success: string;
  cancel_invoice_error: string;
  cancellation_reason_placeholder: string;
  create_credit_note: string;
  credit_note_full: string;
  credit_note_partial: string;
  credit_note_partial_hint: string;
  credit_note_type: string;
  credit_note_reason: string;
  credit_note_items: string;
  credit_note_remaining: string;
  credit_note_original_qty: string;
  credit_note_credit_qty: string;
  credit_note_credit_fraction: string;
  credit_note_success: string;
  credit_note_error: string;
  credit_note_cannot_exceed: string;
  credit_note_no_items: string;
  credit_note_of: string;
  cancellation_of: string;
  cancelled_hint: string;
  related_documents: string;
  status_credit_note: string;
  status_cancellation: string;
  requires_starter_or_higher: string;

  // Settings
  settings_title: string;
  settings_load_error: string;
  settings_save_error: string;
  settings_saved: string;
  company_data: string;
  company_name: string;
  legal_name: string;
  address: string;
  address_extra: string;
  postcode: string;
  city: string;
  country_code: string;
  country_code_placeholder: string;
  tax_number: string;
  vat_id: string;
  email_label: string;
  phone: string;
  commercial_register: string;
  bank_data: string;
  iban: string;
  iban_placeholder: string;
  bic: string;
  bic_placeholder: string;
  invoice_settings: string;
  email_delivery_settings: string;
  send_invoices_to_customer: string;
  send_cancellations_to_customer: string;
  send_credit_notes_to_customer: string;
  attach_pdf_to_email: string;
  attach_xml_to_email: string;
  email_delivery_requires_starter: string;
  customer_email_delivery_hint: string;
  invoice_prefix: string;
  next_invoice_number: string;
  next_invoice_number_positive: string;
  next_invoice_number_must_increase: string;
  invoice_number_already_exists: string;
  auto_issue: string;
  requires_professional: string;
  auto_manual: string;
  auto_draft: string;
  auto_after_payment: string;
  auto_after_fulfillment: string;
  structured_format: string;
  requires_starter: string;
  zugferd: string;
  xrechnung: string;
  default_zugferd_profile: string;
  zugferd_profile_only: string;
  profile_basic: string;
  profile_basicwl: string;
  profile_extended: string;
  profile_minimum: string;
  profile_en16931: string;
  zugferd_profile_info_button: string;
  zugferd_profile_info_title: string;
  zugferd_profile_info_copy: string;
  profile_info_col_profile: string;
  profile_info_col_status: string;
  profile_info_col_notes: string;
  profile_info_minimum: string;
  profile_info_basicwl: string;
  profile_info_basic: string;
  profile_info_en16931: string;
  profile_info_extended: string;
  profile_info_xrechnung: string;
  default_language: string;
  default_language_hint: string;
  lang_german: string;
  lang_english: string;
  saving: string;
  save_settings: string;
  documents_used_label: string;

  // Plan & feature labels
  plan_free: string;
  feature_email_delivery: string;
  feature_credit_notes: string;
  feature_cancellations: string;
  feature_vat_validation: string;
  feature_automation: string;
  feature_priority_support: string;

  // Backend errors
  err_cannot_issue: string;
  err_cannot_issue_customer: string;
  err_shopify_protected_address_access: string;
  err_legal_name_required: string;
  err_address_required: string;
  err_customer_billing_address_required: string;
  err_customer_name_required: string;
  err_customer_company_name_required: string;
  err_postcode_required: string;
  err_city_required: string;
  err_company_name_required: string;
  err_tax_number_required: string;
  err_vat_id_required: string;
  err_email_required: string;
  err_country_required: string;

  // API client errors
  api_bridge_not_init: string;
  api_token_error: string;
  api_error: string;
  session_expired: string;
  download_failed: string;
};

const de: TranslationKeys = {
  nav_overview: 'Übersicht',
  nav_orders: 'Bestellungen',
  nav_invoices: 'Rechnungen',
  nav_settings: 'Einstellungen',
  loading: 'Wird geladen...',
  hide: 'Schließen',

  dashboard_title: 'Übersicht',
  dashboard_load_error: 'Dashboard-Daten konnten nicht geladen werden',
  refresh: 'Aktualisieren',
  invoices_total: 'Rechnungen gesamt',
  draft: 'Entwurf',
  issued: 'Ausgestellt',
  validation_failed: 'Validierung fehlgeschlagen',
  orders_total: 'Bestellungen gesamt',
  paid: 'Bezahlt',
  open: 'Offen',
  unfulfilled: 'Nicht erfüllt',
  latest_invoices: 'Neueste Rechnungen',
  no_invoices_yet: 'Noch keine Rechnungen vorhanden. Erstelle die erste Rechnung auf der Seite Bestellungen.',
  col_invoice: 'Rechnung #',
  col_order: 'Bestellung',
  col_customer: 'Kunde',
  col_date: 'Datum',
  col_total: 'Summe',
  col_status: 'Status',
  col_actions: 'Aktionen',
  current_plan: 'Aktueller Plan',
  billing_period: 'Abrechnungszeitraum',
  reset_on: 'Zurückgesetzt am',
  document_usage: 'Dokumentnutzung',
  remaining_in_period: 'in diesem Zeitraum übrig',
  monthly_limit_reached: 'Du hast dein monatliches Dokumentlimit erreicht. Verwalte deinen Plan, um weitere Rechnungen auszustellen.',
  status_issued: 'Ausgestellt',
  status_draft: 'Entwurf',
  status_cancelled: 'Storniert',
  manage_plan: 'Plan verwalten',
  manage_plan_tooltip: 'SHOPIFY_APP_HANDLE setzen, um den Link zur Planverwaltung zu aktivieren',

  orders_title: 'Bestellungen',
  orders_load_error: 'Shopify-Bestellungen konnten nicht geladen werden',
  latest_shopify_orders: 'Neueste Shopify-Bestellungen',
  orders_loading: 'Bestellungen werden geladen...',
  no_orders_found: 'Keine aktuellen Bestellungen gefunden.',
  create_invoice: 'Rechnung erstellen',
  create_invoice_from_order: 'Rechnung aus Bestellung erstellen',
  order_id: 'Bestell-ID',
  order_id_placeholder: 'z. B. 1234567890',
  creating: 'Wird erstellt...',
  invoice_created: 'wurde erfolgreich erstellt.',
  invoice_already_exists: 'existiert bereits.',
  invoice_already_created: 'Rechnung bereits erstellt',
  invoice_created_hint: 'Wechsle zum Tab Rechnungen, um sie auszustellen und herunterzuladen.',
  reversed_order_hint: 'Erstattete oder stornierte Bestellungen können zusätzliche Dokumente wie Gutschriften oder Stornos erfordern.',
  financial_paid: 'Bezahlt',
  financial_pending: 'Ausstehend',
  financial_authorized: 'Autorisiert',
  financial_partially_paid: 'Teilweise bezahlt',
  financial_refunded: 'Erstattet',
  financial_voided: 'Storniert',
  entries: 'Einträge',
  per_page: 'pro Seite',

  invoices_title: 'Rechnungen',
  invoices_load_error: 'Rechnungen konnten nicht geladen werden',
  monthly_limit_error: 'Monatliches Dokumentlimit erreicht. Bitte verwalte deinen Plan.',
  issue_error: 'Rechnung konnte nicht ausgestellt werden:',
  unknown_error: 'Unbekannter Fehler',
  download_error: 'Download fehlgeschlagen:',
  search_placeholder: 'Nach Rechnung #, Bestellung oder Kunde suchen...',
  filter_all: 'Alle Status',
  no_invoices_empty: 'Noch keine Rechnungen erstellt.',
  no_invoices_filter: 'Keine Rechnungen entsprechen dem Filter.',
  issuing: 'Wird ausgestellt...',
  issue: 'Ausstellen',
  document_limit_reached: 'Dokumentlimit erreicht',
  plan_limit_reached: 'Du hast dein monatliches Limit von {limit} Dokumenten erreicht.',
  documents_used: '{used} / {limit} Dokumente in diesem Zeitraum genutzt.',

  cancel_invoice: 'Rechnung stornieren',
  cancel_invoice_confirm: 'Möchtest du diese Rechnung wirklich stornieren?',
  cancel_invoice_explanation: 'Die Originalrechnung bleibt unverändert. Es wird ein separates Storno-Dokument erstellt.',
  cancel_invoice_success: 'Rechnung erfolgreich storniert.',
  cancel_invoice_error: 'Rechnung konnte nicht storniert werden:',
  cancellation_reason_placeholder: 'Grund für die Stornierung (optional)',
  create_credit_note: 'Gutschrift erstellen',
  credit_note_full: 'Vollständige Gutschrift',
  credit_note_partial: 'Teilweise Gutschrift',
  credit_note_partial_hint: 'Teilweise bedeutet anteilig: 0,5 erstellt eine Gutschrift über 50 % der Position.',
  credit_note_type: 'Gutschriftart',
  credit_note_reason: 'Grund',
  credit_note_items: 'Gutschriftpositionen',
  credit_note_remaining: 'Verbleibend',
  credit_note_original_qty: 'Original',
  credit_note_credit_qty: 'Gutschrift',
  credit_note_credit_fraction: 'Anteil',
  credit_note_success: 'Gutschrift erfolgreich erstellt.',
  credit_note_error: 'Gutschrift konnte nicht erstellt werden:',
  credit_note_cannot_exceed: 'Darf den verbleibenden Betrag nicht überschreiten.',
  credit_note_no_items: 'Keine Gutschriftpositionen verfügbar.',
  credit_note_of: 'Gutschrift zu',
  cancellation_of: 'Storno zu',
  cancelled_hint: 'Storniert mit {number}',
  related_documents: 'Zugehörige Dokumente',
  status_credit_note: 'Gutschrift',
  status_cancellation: 'Storno',
  requires_starter_or_higher: 'Erfordert den Starter-Plan oder höher',

  settings_title: 'Einstellungen',
  settings_load_error: 'Einstellungen konnten nicht geladen werden',
  settings_save_error: 'Einstellungen konnten nicht gespeichert werden',
  settings_saved: 'Einstellungen wurden erfolgreich gespeichert.',
  company_data: 'Unternehmensdaten',
  company_name: 'Firmenname',
  legal_name: 'Rechtlicher Name',
  address: 'Adresse',
  address_extra: 'Adresszusatz',
  postcode: 'PLZ',
  city: 'Stadt',
  country_code: 'Ländercode',
  country_code_placeholder: 'z. B. DE',
  tax_number: 'Steuernummer',
  vat_id: 'USt-IdNr.',
  email_label: 'E-Mail',
  phone: 'Telefon',
  commercial_register: 'Handelsregisternummer',
  bank_data: 'Bankdaten',
  iban: 'IBAN',
  iban_placeholder: 'DE89 3704 0044 0532 0130 00',
  bic: 'BIC',
  bic_placeholder: 'COBADEFFXXX',
  invoice_settings: 'Rechnungseinstellungen',
  email_delivery_settings: 'E-Mail-Versand',
  send_invoices_to_customer: 'Rechnungen an Kunden-E-Mail senden',
  send_cancellations_to_customer: 'Stornos an Kunden-E-Mail senden',
  send_credit_notes_to_customer: 'Gutschriften an Kunden-E-Mail senden',
  attach_pdf_to_email: 'PDF an E-Mails anhängen',
  attach_xml_to_email: 'XML an E-Mails anhängen',
  email_delivery_requires_starter: 'E-Mail-Versand erfordert den Starter-Plan oder höher',
  customer_email_delivery_hint: 'PDF wird immer angehängt. XML wird nur angehängt, wenn es aktiviert ist und Shopify eine Kunden-E-Mail liefert.',
  invoice_prefix: 'Rechnungspräfix',
  next_invoice_number: 'Nächste Rechnungsnummer',
  next_invoice_number_positive: 'Die nächste Rechnungsnummer muss eine positive ganze Zahl sein.',
  next_invoice_number_must_increase: 'Die nächste Rechnungsnummer muss größer als die aktuelle Nummer {number} sein.',
  invoice_number_already_exists: 'Diese Rechnungsnummer existiert bereits. Bitte wählen Sie eine höhere Nummer.',
  auto_issue: 'Automatische Ausstellung',
  requires_professional: 'Erfordert den Professional-Plan',
  auto_manual: 'Manuell',
  auto_draft: 'Automatisch als Entwurf',
  auto_after_payment: 'Automatisch nach Zahlung ausstellen',
  auto_after_fulfillment: 'Automatisch nach Fulfillment ausstellen',
  structured_format: 'Standardformat für strukturierte Rechnungen',
  requires_starter: 'XRechnung erfordert den Starter-Plan',
  zugferd: 'ZUGFeRD',
  xrechnung: 'XRechnung',
  default_zugferd_profile: 'Standard-ZUGFeRD-Profil',
  zugferd_profile_only: 'Nur bei ZUGFeRD-Format verfügbar',
  profile_basic: 'Basic (COMFORT)',
  profile_basicwl: 'Basic WL',
  profile_extended: 'Extended (EXTENDED)',
  profile_minimum: 'Minimum (MINIMUM)',
  profile_en16931: 'EN 16931 (COMFORT)',
  zugferd_profile_info_button: 'ZUGFeRD-Profile vergleichen',
  zugferd_profile_info_title: 'ZUGFeRD-Profile',
  zugferd_profile_info_copy: 'Wähle das kleinste Profil, das dein Empfänger akzeptiert. XRechnung folgt zusätzlich deutschen Regeln.',
  profile_info_col_profile: 'Profil',
  profile_info_col_status: 'Status',
  profile_info_col_notes: 'Hinweis',
  profile_info_minimum: 'Keine Positionen, nur Kopfsummen',
  profile_info_basicwl: 'Keine Positionen, mit Steueraufschlüsselung',
  profile_info_basic: 'Positionen mit korrekten Nettobeträgen',
  profile_info_en16931: 'Vollständige Struktur und korrekte Berechnungen',
  profile_info_extended: 'Wie EN16931; erweiterte Felder werden aktuell nicht genutzt',
  profile_info_xrechnung: 'EN16931 plus Käuferreferenz und deutsche Regeln',
  default_language: 'Standardsprache',
  default_language_hint: 'Betrifft nur die generierte PDF-Datei. Die App-Oberfläche passt sich an die Storesprache an.',
  lang_german: 'Deutsch',
  lang_english: 'Englisch',
  saving: 'Wird gespeichert...',
  save_settings: 'Einstellungen speichern',
  documents_used_label: 'Dokumente genutzt',

  plan_free: 'Kostenlos',
  feature_email_delivery: 'E-Mail-Versand',
  feature_credit_notes: 'Gutschriften',
  feature_cancellations: 'Stornos',
  feature_vat_validation: 'USt-IdNr.-Prüfung',
  feature_automation: 'Automatisierung',
  feature_priority_support: 'Priorisierter Support',

  err_cannot_issue: 'Rechnung kann nicht ausgestellt werden. Bitte füllen Sie die erforderlichen Felder in den Einstellungen aus.',
  err_cannot_issue_customer: 'Rechnung kann nicht ausgestellt werden. Bitte prüfen Sie die Kundendaten der Shopify-Bestellung.',
  err_shopify_protected_address_access: 'Shopify verweigert den Zugriff auf die Rechnungs- oder Lieferadresse dieser Bestellung. Aktivieren Sie die erforderlichen geschützten Kundendatenfelder für InvoicePilot im Shopify Partner Dashboard und versuchen Sie es erneut. App-Berechtigungen allein gewähren keinen Zugriff auf diese Felder.',
  err_legal_name_required: 'Rechtlicher Name ist erforderlich.',
  err_address_required: 'Adresse ist erforderlich.',
  err_customer_billing_address_required: 'Die Rechnungsadresse des Kunden fehlt.',
  err_customer_name_required: 'Der Kundenname fehlt in der Shopify-Bestellung.',
  err_customer_company_name_required: 'Der Firmenname des Kunden fehlt in der Shopify-Bestellung.',
  err_postcode_required: 'PLZ ist erforderlich.',
  err_city_required: 'Stadt ist erforderlich.',
  err_company_name_required: 'Firmenname ist erforderlich.',
  err_tax_number_required: 'Steuernummer ist erforderlich.',
  err_vat_id_required: 'USt-IdNr. ist erforderlich.',
  err_email_required: 'E-Mail ist erforderlich.',
  err_country_required: 'Ländercode ist erforderlich.',

  api_bridge_not_init: 'Shopify App Bridge wurde nicht initialisiert',
  api_token_error: 'Authentifizierungstoken konnte nicht abgerufen werden',
  api_error: 'API-Fehler:',
  session_expired: 'Sitzung abgelaufen. Bitte lade die Seite neu.',
  download_failed: 'Download fehlgeschlagen:',
};

const en: TranslationKeys = {
  nav_overview: 'Overview',
  nav_orders: 'Orders',
  nav_invoices: 'Invoices',
  nav_settings: 'Settings',
  loading: 'Loading...',
  hide: 'Close',

  dashboard_title: 'Overview',
  dashboard_load_error: 'Dashboard data could not be loaded',
  refresh: 'Refresh',
  invoices_total: 'Total invoices',
  draft: 'Draft',
  issued: 'Issued',
  validation_failed: 'Validation failed',
  orders_total: 'Total orders',
  paid: 'Paid',
  open: 'Open',
  unfulfilled: 'Unfulfilled',
  latest_invoices: 'Latest invoices',
  no_invoices_yet: 'No invoices yet. Create the first invoice on the Orders page.',
  col_invoice: 'Invoice #',
  col_order: 'Order',
  col_customer: 'Customer',
  col_date: 'Date',
  col_total: 'Total',
  col_status: 'Status',
  col_actions: 'Actions',
  current_plan: 'Current plan',
  billing_period: 'Billing period',
  reset_on: 'Resets on',
  document_usage: 'Document usage',
  remaining_in_period: 'remaining in this period',
  monthly_limit_reached: 'You have reached your monthly document limit. Manage your plan to issue more invoices.',
  status_issued: 'Issued',
  status_draft: 'Draft',
  status_cancelled: 'Cancelled',
  manage_plan: 'Manage plan',
  manage_plan_tooltip: 'Set SHOPIFY_APP_HANDLE to enable the plan management link',

  orders_title: 'Orders',
  orders_load_error: 'Shopify orders could not be loaded',
  latest_shopify_orders: 'Latest Shopify orders',
  orders_loading: 'Loading orders...',
  no_orders_found: 'No current orders found.',
  create_invoice: 'Create invoice',
  create_invoice_from_order: 'Create invoice from order',
  order_id: 'Order ID',
  order_id_placeholder: 'e.g. 1234567890',
  creating: 'Creating...',
  invoice_created: 'was successfully created.',
  invoice_already_exists: 'already exists.',
  invoice_already_created: 'Invoice already created',
  invoice_created_hint: 'Switch to the Invoices tab to issue and download it.',
  reversed_order_hint: 'Refunded or voided orders may require additional documents such as credit notes or cancellations.',
  financial_paid: 'Paid',
  financial_pending: 'Pending',
  financial_authorized: 'Authorized',
  financial_partially_paid: 'Partially paid',
  financial_refunded: 'Refunded',
  financial_voided: 'Voided',
  entries: 'entries',
  per_page: 'per page',

  invoices_title: 'Invoices',
  invoices_load_error: 'Invoices could not be loaded',
  monthly_limit_error: 'Monthly document limit reached. Please manage your plan.',
  issue_error: 'Invoice could not be issued:',
  unknown_error: 'Unknown error',
  download_error: 'Download failed:',
  search_placeholder: 'Search by invoice #, order or customer...',
  filter_all: 'All statuses',
  no_invoices_empty: 'No invoices created yet.',
  no_invoices_filter: 'No invoices match the filter.',
  issuing: 'Issuing...',
  issue: 'Issue',
  document_limit_reached: 'Document limit reached',
  plan_limit_reached: 'You have reached your monthly limit of {limit} documents.',
  documents_used: '{used} / {limit} documents used in this period.',

  cancel_invoice: 'Cancel invoice',
  cancel_invoice_confirm: 'Are you sure you want to cancel this invoice?',
  cancel_invoice_explanation: 'The original invoice will remain unchanged. A separate cancellation document will be created.',
  cancel_invoice_success: 'Invoice cancelled successfully.',
  cancel_invoice_error: 'Invoice could not be cancelled:',
  cancellation_reason_placeholder: 'Reason for cancellation (optional)',
  create_credit_note: 'Create credit note',
  credit_note_full: 'Full credit',
  credit_note_partial: 'Partial credit',
  credit_note_partial_hint: 'Partial means a percentage/fraction: 0.5 creates a credit note for 50% of the line item.',
  credit_note_type: 'Credit note type',
  credit_note_reason: 'Reason',
  credit_note_items: 'Credit note items',
  credit_note_remaining: 'Remaining',
  credit_note_original_qty: 'Original',
  credit_note_credit_qty: 'Credit',
  credit_note_credit_fraction: 'Fraction',
  credit_note_success: 'Credit note created successfully.',
  credit_note_error: 'Credit note could not be created:',
  credit_note_cannot_exceed: 'Cannot exceed the remaining creditable quantity.',
  credit_note_no_items: 'No creditable items available.',
  credit_note_of: 'Credit note of',
  cancellation_of: 'Cancellation of',
  cancelled_hint: 'Cancelled with {number}',
  related_documents: 'Related documents',
  status_credit_note: 'Credit note',
  status_cancellation: 'Cancellation',
  requires_starter_or_higher: 'Requires Starter plan or higher',

  settings_title: 'Settings',
  settings_load_error: 'Settings could not be loaded',
  settings_save_error: 'Settings could not be saved',
  settings_saved: 'Settings were saved successfully.',
  company_data: 'Company details',
  company_name: 'Company name',
  legal_name: 'Legal name',
  address: 'Address',
  address_extra: 'Address supplement',
  postcode: 'Postal code',
  city: 'City',
  country_code: 'Country code',
  country_code_placeholder: 'e.g. DE',
  tax_number: 'Tax number',
  vat_id: 'VAT ID',
  email_label: 'Email',
  phone: 'Phone',
  commercial_register: 'Commercial register number',
  bank_data: 'Bank details',
  iban: 'IBAN',
  iban_placeholder: 'DE89 3704 0044 0532 0130 00',
  bic: 'BIC',
  bic_placeholder: 'COBADEFFXXX',
  invoice_settings: 'Invoice settings',
  email_delivery_settings: 'Email delivery',
  send_invoices_to_customer: 'Send invoices to the customer email',
  send_cancellations_to_customer: 'Send cancellations to the customer email',
  send_credit_notes_to_customer: 'Send credit notes to the customer email',
  attach_pdf_to_email: 'Attach PDF to emails',
  attach_xml_to_email: 'Attach XML to emails',
  email_delivery_requires_starter: 'Email delivery requires the Starter plan or higher',
  customer_email_delivery_hint: 'PDF is always attached. XML is attached only when enabled and Shopify provides a customer email.',
  invoice_prefix: 'Invoice prefix',
  next_invoice_number: 'Next invoice number',
  next_invoice_number_positive: 'Next invoice number must be a positive whole number.',
  next_invoice_number_must_increase: 'Next invoice number must be greater than the current number {number}.',
  invoice_number_already_exists: 'This invoice number already exists. Please choose a higher number.',
  auto_issue: 'Automatic issuance',
  requires_professional: 'Requires Professional plan',
  auto_manual: 'Manual',
  auto_draft: 'Automatically as draft',
  auto_after_payment: 'Automatically issue after payment',
  auto_after_fulfillment: 'Automatically issue after fulfillment',
  structured_format: 'Default format for structured invoices',
  requires_starter: 'XRechnung requires Starter plan',
  zugferd: 'ZUGFeRD',
  xrechnung: 'XRechnung',
  default_zugferd_profile: 'Default ZUGFeRD profile',
  zugferd_profile_only: 'Only available with ZUGFeRD format',
  profile_basic: 'Basic (COMFORT)',
  profile_basicwl: 'Basic WL',
  profile_extended: 'Extended (EXTENDED)',
  profile_minimum: 'Minimum (MINIMUM)',
  profile_en16931: 'EN 16931 (COMFORT)',
  zugferd_profile_info_button: 'Compare ZUGFeRD profiles',
  zugferd_profile_info_title: 'ZUGFeRD profiles',
  zugferd_profile_info_copy: 'Choose the smallest profile your recipient accepts. XRechnung also applies German rules.',
  profile_info_col_profile: 'Profile',
  profile_info_col_status: 'Status',
  profile_info_col_notes: 'Notes',
  profile_info_minimum: 'No line items, header totals only',
  profile_info_basicwl: 'No line items, with tax breakdown',
  profile_info_basic: 'Line items with correct net amounts',
  profile_info_en16931: 'Full structure and correct calculations',
  profile_info_extended: 'Same as EN16931; extended fields are not used yet',
  profile_info_xrechnung: 'EN16931 plus buyer reference and German rules',
  default_language: 'Default language',
  default_language_hint: 'Only affects the generated PDF. The app interface adapts to your store language.',
  lang_german: 'German',
  lang_english: 'English',
  saving: 'Saving...',
  save_settings: 'Save settings',
  documents_used_label: 'documents used',

  plan_free: 'Free',
  feature_email_delivery: 'Email delivery',
  feature_credit_notes: 'Credit notes',
  feature_cancellations: 'Cancellations',
  feature_vat_validation: 'VAT ID validation',
  feature_automation: 'Automation',
  feature_priority_support: 'Priority support',

  err_cannot_issue: 'Cannot issue invoice. Please complete the required fields in Settings.',
  err_cannot_issue_customer: 'Cannot issue invoice. Please check the customer details on the Shopify order.',
  err_shopify_protected_address_access: 'Shopify denied access to this order’s billing or shipping address. Enable the required protected customer data fields for InvoicePilot in the Shopify Partner Dashboard, then retry. App permissions alone do not grant access to these fields.',
  err_legal_name_required: 'Legal name is required.',
  err_address_required: 'Address is required.',
  err_customer_billing_address_required: 'The customer billing address is missing.',
  err_customer_name_required: 'The customer name is missing from the Shopify order.',
  err_customer_company_name_required: 'The customer company name is missing from the Shopify order.',
  err_postcode_required: 'Postal code is required.',
  err_city_required: 'City is required.',
  err_company_name_required: 'Company name is required.',
  err_tax_number_required: 'Tax number is required.',
  err_vat_id_required: 'VAT ID is required.',
  err_email_required: 'Email is required.',
  err_country_required: 'Country code is required.',

  api_bridge_not_init: 'Shopify App Bridge was not initialized',
  api_token_error: 'Authentication token could not be retrieved',
  api_error: 'API error:',
  session_expired: 'Session expired. Please reload the page.',
  download_failed: 'Download failed:',
};

const translations: Record<string, TranslationKeys> = { de, en };

let currentLocale = 'de';

export function setLocale(locale: string): void {
  currentLocale = locale.startsWith('en') ? 'en' : 'de';
}

export function getLocale(): string {
  return currentLocale;
}

export function t(key: keyof TranslationKeys, params?: Record<string, string | number>): string {
  let text = translations[currentLocale]?.[key] ?? translations.de[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    }
  }
  return text;
}

export function translateBackendError(message: string): string {
  const lower = message.toLowerCase();
  if (lower.includes('shopify denied access') && lower.includes('address')) {
    return t('err_shopify_protected_address_access');
  }

  const customerBillingAddressMissing = lower.includes('customer billing address');
  const customerNameMissing = lower.includes('customer name is required');
  const customerCompanyNameMissing = lower.includes('customer company name');
  const customerDataMissing = customerBillingAddressMissing || customerNameMissing || customerCompanyNameMissing;

  // Collect individual field errors
  const parts: string[] = [];
  if (lower.includes('legal name')) parts.push(t('err_legal_name_required'));
  if (customerBillingAddressMissing) {
    parts.push(t('err_customer_billing_address_required'));
  } else if (lower.includes('address') && !lower.includes('address supplement')) {
    parts.push(t('err_address_required'));
  }
  if (customerNameMissing) parts.push(t('err_customer_name_required'));
  if (customerCompanyNameMissing) parts.push(t('err_customer_company_name_required'));
  if (lower.includes('postcode') || lower.includes('postal code')) parts.push(t('err_postcode_required'));
  if (lower.includes('city')) parts.push(t('err_city_required'));
  if (lower.includes('company name') && !customerCompanyNameMissing) parts.push(t('err_company_name_required'));
  if (lower.includes('tax number')) parts.push(t('err_tax_number_required'));
  if (lower.includes('vat id')) parts.push(t('err_vat_id_required'));
  if (lower.includes('email')) parts.push(t('err_email_required'));
  if (lower.includes('country')) parts.push(t('err_country_required'));

  if (parts.length > 0) {
    const context = customerDataMissing ? t('err_cannot_issue_customer') : t('err_cannot_issue');
    return t('issue_error') + ' ' + context + ' ' + parts.join(' ');
  }

  if (lower.includes('cannot issue invoice') || lower.includes('please complete required fields')) {
    return t('issue_error') + ' ' + t('err_cannot_issue');
  }

  return message;
}
